import React, { FunctionComponent, useContext } from 'react';
import { AppStore } from '../../store/app.context';
import { Link } from 'gatsby';

export interface IPageBackLinkProps {
  children: React.ReactNode;
  className?: string;
}

export const PageBackLink: FunctionComponent<IPageBackLinkProps> = ({
  children,
  className
}) => {
  const {
    state: {
      showPageState: { prevUrl, currentLanguage }
    }
  } = useContext(AppStore);
  const lang = currentLanguage === 'en' ? '' : currentLanguage;
  return (
    <Link className={className} to={prevUrl ? prevUrl : `/${lang}`}>
      {children}
    </Link>
  );
};
